module.exports = __webpack_public_path__ + "img/52114117_L.e593b995.png";